var codeblock_default = {
  "blockStyleSpacing": "TFQ7K",
  "codeBlock": "WrdLk TFQ7K",
  "renderedInTable": "iP3BX"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
